/* wh1-shell.js : WILDHORN DARK shell runtime (1:1 port of /srv/wildhorn-lp/site/assets/site.js).
   Same behaviour as product-v6: rotating top bar, headroom header, slide-in drawer (Esc closes),
   FAQ accordion (native <details>), cart badge, email band. Exposes window.WH helpers:
   WH.toast(msg[, 'error']), WH.setCart(n), WH.refreshCart(), WH.openMenu(), WH.closeMenu(),
   WH.previewForm(form, okMsg).
   Loaded with defer from layout/theme.liquid BEFORE wh1-product/pages/policies/cart.js,
   so page scripts can use WH at DOMContentLoaded. */
(function () {
  'use strict';
  var d = document, WH = window.WH = window.WH || {};
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* toast (host carries .wh1-sc so the scoped shell CSS applies) */
  WH.toast = function (msg, kind) {
    var t = d.getElementById('wh-toast');
    if (!t) {
      var host = d.createElement('div'); host.className = 'wh1-sc wh1-toast-host';
      t = d.createElement('div'); t.id = 'wh-toast'; t.className = 'wh-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      host.appendChild(t); d.body.appendChild(host);
    }
    t.textContent = msg; t.classList.toggle('wh-toast--err', kind === 'error'); t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2400);
  };

  /* top bar: rotate .ann6__m every 4 s (off with reduced motion) */
  function topbar() {
    var ms = d.querySelectorAll('#announce .ann6__m'), k = 0;
    if (ms.length < 2 || reduce) return;
    setInterval(function () {
      ms[k].classList.remove('on'); ms[k].setAttribute('aria-hidden', 'true');
      k = (k + 1) % ms.length;
      ms[k].classList.add('on'); ms[k].removeAttribute('aria-hidden');
    }, 4000);
  }

  /* headroom: hide the sticky header on scroll down, show it on scroll up */
  function headroom() {
    var h = d.querySelector('.hdr'); if (!h) return;
    var last = window.scrollY, tick = false;
    function upd() {
      var y = window.scrollY;
      if (y > last + 6 && y > 140) h.classList.add('hdr--up');
      else if (y < last - 6 || y < 140) h.classList.remove('hdr--up');
      last = y; tick = false;
    }
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    h.addEventListener('focusin', function () { h.classList.remove('hdr--up'); });
  }

  /* drawer menu */
  function drawer() {
    var dr = d.getElementById('dr6'), b = d.querySelector('.hdr__burger'), back = null;
    if (!dr || !b) return;
    function focusables() { return [].slice.call(dr.querySelectorAll('a[href],button')); }
    function op() {
      back = d.activeElement;
      dr.removeAttribute('inert'); dr.classList.add('on'); dr.setAttribute('aria-hidden', 'false');
      b.setAttribute('aria-expanded', 'true'); d.body.style.overflow = 'hidden';
      var x = dr.querySelector('.dr6__x'); if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) { } }, 30);
    }
    function cl() {
      if (!dr.classList.contains('on')) return;
      dr.classList.remove('on'); dr.setAttribute('aria-hidden', 'true'); dr.setAttribute('inert', '');
      b.setAttribute('aria-expanded', 'false'); d.body.style.overflow = '';
      if (back && back.focus) try { back.focus({ preventScroll: true }); } catch (e) { }
    }
    b.addEventListener('click', op);
    dr.querySelectorAll('[data-dr-close]').forEach(function (e) { e.addEventListener('click', cl); });
    dr.querySelectorAll('a[href^="#"]').forEach(function (a) { a.addEventListener('click', cl); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cl(); return; }
      if (e.key === 'Tab' && dr.classList.contains('on')) {
        var f = focusables(); if (!f.length) return;
        var first = f[0], lastEl = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && d.activeElement === lastEl) { e.preventDefault(); first.focus(); }
      }
    });
    WH.openMenu = op; WH.closeMenu = cl;
  }

  /* FAQ accordion: native <details>. Add data-acc-single on .acc to keep one item open.
     A URL hash pointing at a <details> (or inside one) opens it. */
  function acc() {
    d.querySelectorAll('.acc[data-acc-single]').forEach(function (a) {
      a.addEventListener('toggle', function (e) {
        var t = e.target; if (t.tagName !== 'DETAILS' || !t.open) return;
        a.querySelectorAll('details[open]').forEach(function (o) { if (o !== t) o.open = false; });
      }, true);
    });
    function openHash() {
      if (!location.hash || location.hash.length < 2) return;
      var el; try { el = d.querySelector(decodeURIComponent(location.hash)); } catch (e) { return; }
      var det = el && (el.tagName === 'DETAILS' ? el : el.closest && el.closest('details'));
      if (det) det.open = true;
    }
    openHash(); addEventListener('hashchange', openHash);
  }

  /* cart badge (#cartBadge, rendered with {{ cart.item_count }}). Stays in sync with:
     - WH.setCart(n) / WH.refreshCart()
     - the theme cart drawer (snippets/wh-cart-drawer writes the count into [data-cart-count])
     - Horizon 'cart:update' events */
  var lastCount = null;
  function badge() { return d.getElementById('cartBadge'); }
  WH.setCart = function (n) {
    var b = badge(); if (!b) return;
    n = Math.max(0, parseInt(n, 10) || 0);
    if (b.textContent !== String(n)) b.textContent = n;
    sync(b);
  };
  function sync(b) {
    var n = Math.max(0, parseInt(b.textContent, 10) || 0);
    b.hidden = n === 0;
    if (lastCount !== null && n > lastCount) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    lastCount = n;
  }
  WH.refreshCart = function () {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { WH.setCart(c.item_count); return c; })
      .catch(function () { });
  };
  function cartBadge() {
    var b = badge(); if (!b) return;
    lastCount = Math.max(0, parseInt(b.textContent, 10) || 0);
    if (window.MutationObserver) new MutationObserver(function () { sync(b); }).observe(b, { childList: true, characterData: true, subtree: true });
    d.addEventListener('cart:update', function (e) {
      var x = e && e.detail || {}, r = x.resource || x.cart || {}, n = r.item_count;
      if (n == null && x.data) n = x.data.itemCount;
      if (n != null) WH.setCart(n); else WH.refreshCart();
    });
    addEventListener('pageshow', function (e) { if (e.persisted) WH.refreshCart(); });
  }

  /* preview forms: validates, then shows a toast (nothing sent). Only for forms marked data-preview. */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function firstBad(f) {
    var bad = null;
    [].slice.call(f.querySelectorAll('input,textarea,select')).some(function (i) {
      if (i.type === 'hidden') return false;
      var v = (i.value || '').trim();
      if (i.required && !v) { bad = i; return true; }
      if (i.type === 'email' && v && !EMAIL.test(v)) { bad = i; return true; }
      return false;
    });
    return bad;
  }
  function badMsg(i) { return i.type === 'email' ? 'Please enter a valid email.' : 'Please fill in this field.'; }
  WH.previewForm = function (f, okMsg) {
    if (!f || f._wh) return; f._wh = true;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = firstBad(f);
      if (bad) { WH.toast(badMsg(bad), 'error'); bad.focus(); return; }
      WH.toast(okMsg || 'Preview page: nothing was sent.'); f.reset();
    });
  };
  /* real Shopify forms (email band = {% form 'customer' %}): same validation toast, then submit for real */
  WH.validateForm = function (f) {
    if (!f || f._whv) return; f._whv = true;
    f.addEventListener('submit', function (e) {
      var bad = firstBad(f);
      if (bad) { e.preventDefault(); WH.toast(badMsg(bad), 'error'); bad.focus(); }
    });
  };
  function forms() {
    var band = d.getElementById('email-list');
    if (band) {
      var f = band.querySelector('form'); if (f) WH.validateForm(f);
      var sf = band.querySelector('[data-wh1-state]'), st = sf && sf.getAttribute('data-wh1-state');
      if (st === 'ok') WH.toast(band.getAttribute('data-ok') || 'You are on the list.');
      else if (st === 'error') WH.toast(band.getAttribute('data-err') || 'Please enter a valid email.', 'error');
    }
    d.querySelectorAll('form[data-preview]').forEach(function (x) { WH.previewForm(x, x.getAttribute('data-preview') || undefined); });
  }

  function init() { topbar(); headroom(); drawer(); acc(); cartBadge(); forms(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
